"use client";

import { useEffect, useState } from "react";

// True when the viewer is signed in as the Full Service admin
// (sales@recruitgraphics.com — see getFullServiceAdmin in lib/full_service.js).
// Pages use it to show admin-only extras such as watermark-free downloads.
export default function useSalesAdmin() {
  const [admin, setAdmin] = useState(false);
  useEffect(() => {
    let cancelled = false;
    fetch("/api/admin/full-service/whoami", { cache: "no-store" })
      .then((r) => r.json()).then((d) => { if (!cancelled) setAdmin(!!d?.admin); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return admin;
}
